import { useCallback, useEffect, useRef, useState } from 'react';
import './index.scss';

const OPTIONS = [
  { lang: 'de', code: 'DE', name: 'Deutsch', key: 'd' },
  { lang: 'en', code: 'EN', name: 'English', key: 'e' },
];

// The exit (boxes fade, glass clears while the page zooms out) is timed in
// index.scss and App.scss; the gate unmounts once the glass is fully clear.
const EXIT_MS = 1250;

const LanguageSelect = ({ onSelect, onDone }) => {
  const [picked, setPicked] = useState(null);
  const pickedRef = useRef(null);

  const pick = useCallback((lang) => {
    if (pickedRef.current) return;
    pickedRef.current = lang;
    setPicked(lang);
    onSelect(lang);

    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(onDone, reduceMotion ? 0 : EXIT_MS);
  }, [onSelect, onDone]);

  useEffect(() => {
    const handleKey = (event) => {
      const option = OPTIONS.find(({ key }) => key === event.key.toLowerCase());
      if (option) pick(option.lang);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [pick]);

  return (
    <div
      className={`lang-select${picked ? ' is-leaving' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="lang-title"
    >
      <div className="lang-glass" aria-hidden="true" />

      <div className="lang-content">
        <h1 className="lang-title" id="lang-title">Language</h1>

        <div className="lang-options">
          {OPTIONS.map(({ lang, code, name }) => (
            <button
              key={lang}
              className={[
                'lang-button',
                `lang-button-${lang}`,
                picked === lang ? 'is-picked' : '',
                picked && picked !== lang ? 'is-dropped' : '',
              ].filter(Boolean).join(' ')}
              type="button"
              lang={lang}
              onClick={() => pick(lang)}
              disabled={Boolean(picked)}
            >
              <span className="lang-code">{code}</span>
              <span className="lang-name">{name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSelect;
